import React from 'react';
import { ResetPassword } from '../../components/ResetPassword';

const ResetPasswordEntry = () => <ResetPassword />;

export default ResetPasswordEntry;
